import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OfbizForm, OfbizFormsService, RemoteFormData } from '@urbannex/ofbiz-forms';
import { SelectedValue, getFields, getTarget } from '@urbannex/view-containers';
import { PART_FORMS } from '../../forms';
import { FormBuilder, FormControl } from '@angular/forms';
import { take } from 'rxjs';

@Component({
  selector: 'pty-customer-basic-info',
  templateUrl: './customer-basic-info.component.html',
  styleUrls: ['./customer-basic-info.component.scss']
})
export class CustomerBasicInfoComponent implements OnChanges {
  
  @Input() partyId:string;
  hasValue = false;
  
  selectedValue:SelectedValue;
  title = "Basic Information";
  ofbizForm = new OfbizForm({
    formName:"ViewPartyPerson",
    formLocation:"component://kwikstore/widget/PartyForms.xml",
    fields:getFields("ViewPartyPerson",PART_FORMS),
    target:getTarget("ViewPartyPerson",PART_FORMS) || "",
    appContext:"party",
    local:true,
    entityName:"Party",
    layout:"singleColumnLayout"
  });
  target = this.ofbizForm.target;
  state:any;
  tempForm = this.fb.group({}); // Used to get the default value from backend 

  constructor(
    private fb:FormBuilder,
    private ofbizFormsService:OfbizFormsService){
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["partyId"]){
      let data:RemoteFormData = {
        formData: {
          formName: this.ofbizForm.formName,
          formLocation: this.ofbizForm.formLocation,
        },
        parameters:{
          "partyId":this.partyId
        }
      }
      let parameters = data.parameters;
      Object.keys(parameters).forEach(key =>{
        if(this.tempForm.get(key)){
          console.log("Field exists",this.tempForm.get(key),{key:parameters[key]});
          this.tempForm.patchValue({[key]:parameters[key]});
        }else{
          this.tempForm.addControl(key,new FormControl(parameters[key]));
        }
      });
      console.log(this.tempForm.value);
      this.ofbizFormsService.getValue(data.formData,this.tempForm.value,null)
      .pipe(take(1))
      .subscribe((responseData) => {
        const statusCode = responseData["statusCode"];
        switch (statusCode) {
          case 200:
          if(responseData["successMessage"] == "OK"){
            const data = responseData["data"];
            const formData = data["formData"];
            if(data["responseMessage"] == "success"){
              //this.responseMessage = "success";
              //let formFields:OfbizField[] = this.ofbizForm.fields;
              let dataFields:any[] = formData["fields"];
              //this.parameters = dataFields;
              let titlePlaceHolder:any = {"description":"","id":""}
              this.ofbizForm.fields.forEach(field => {
                let dataField = dataFields.find(element => field.name == Object.keys(element)[0]);
                if(dataField){
                  field.value = dataField[field.name];
                  if(field.name === this.ofbizForm.titleDescriptionField){
                    titlePlaceHolder.description = dataField[field.name];
                  }
                  if(field.name === this.ofbizForm.idFieldName){
                    titlePlaceHolder.id = dataField[field.name];
                  }
                }
              });
              console.log({AddFormAfter:this.ofbizForm});
              this.title = titlePlaceHolder.description+" - ["+titlePlaceHolder.id+"]";
              this.hasValue = true;
            }
          }
          break;
        case 404:
        
          break;
        case 500:
        
          break;
        default:
          break;
        }
        
      })

      /* this.state = {
        selectedValue:{
        event:"view",
        type:this.ofbizForm.formName,
        label:"",
        data:{
          formData:{
            formName:this.ofbizForm.formName,
            formLocation:this.ofbizForm.formLocation,
          },
          parameters:{
            "partyId":this.partyId
          }      
          }
        }
      }; */

    }
  }

  resetAction(e){

  }


  openDialogContainer(e){}
}
